import { isFullVideoData } from "../../utils";
import { isEEA } from "./isEEA";

export const safelyRemoveScript = (scriptId, controller) => {
  const scriptElement = document.getElementById(scriptId);
  if (scriptElement && document.body.contains(scriptElement)) {
    document.body.removeChild(scriptElement);
  }
  // abort signal to remove event listeners
  controller?.abort();
};

export const pushData = (player, strategy, script) => {
  window._cbv_strategies = window._cbv_strategies || [];
  if (!window._cbv_strategies.includes(strategy)) {
    window._cbv_strategies.push(strategy);
  }

  window._cbv = window._cbv || [];

  window._sf_async_config.autoDetect = false;
  window._cbv.push(player);
  // load chartbeat video script if it's not already on the page
  if (!document.getElementById("chartbeat_video")) {
    document.body.appendChild(script);
  }
};

export const shouldPushData = (isPlayerPushed, videoData, signal, script) => {
  return (
    !isPlayerPushed &&
    isFullVideoData(videoData) &&
    !!signal &&
    !!script &&
    !!window._sf_async_config &&
    !isEEA()
  );
};
